unable to read source [project]/packages/src/theme/PapercupTheme.ts